export default {
  setAuth: (state, payload) => {
    state = Object.assign(state, payload);
    state.token = payload;
  },
  setMsToken: (state, payload) => {
    state.msToken = payload;
  },
};
